<template>
    <div class="action-bar">
        <b-navbar toggleable="md" type="dark" variant="info">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand href="#">Harven Surf</b-navbar-brand>            
            <b-nav-text href="#">Caja:{{caja}} - Almacén:{{location}} - Usuario POS: {{this.$store.state.UserCardId.return_value}} - Documento: {{this.$store.state.curOrder}}</b-nav-text>            
            <b-collapse is-nav id="nav_collapse">
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-spinner v-if="processing" small type="grow"></b-spinner> 
                    <b-nav-item to="cashmovs">Movimientos de caja</b-nav-item>  
                    <b-nav-item-dropdown text="Acciones" right>
                        <b-dropdown-item href="#" @click="park">Aparcar</b-dropdown-item>
                         <!--<b-dropdown-item href="#">Recuperar</b-dropdown-item> -->
                         <!--<b-dropdown-item href="#">Imprimir cod. barras</b-dropdown-item> -->
                         <!--<b-dropdown-item href="#">Aparcar e imprimir</b-dropdown-item> -->
                        <b-dropdown-item href="#" @click="cancelSale">Cancelar venta</b-dropdown-item>
                        <b-dropdown-item v-if="this.$store.state.curDocType == 0" href="#" @click="convertOrder">Convertir a Pedido</b-dropdown-item>
                    </b-nav-item-dropdown>      
                </b-navbar-nav> 
            </b-collapse>
             <b-nav-text href="#">v:1.0.85b</b-nav-text>  
        </b-navbar>
         <!-- Modal Component para Errores/Advertencias -->
        <b-modal ref="ModalRefPayments" id="modal2" title="Registro de cobro">
            <b-list-group>
                <p class="my-4">{{ModalMsg}}</p>
            </b-list-group>
        </b-modal>
        <!-- Modal Component para confirmar eliminación de una venta -->
        <b-modal @ok="cancelSaleConfirmed" ref="ModalRefCancelSale" id="modal2" title="Registro de cobro">
            <b-list-group>
                <p class="my-4">{{ModalMsg}}</p>
            </b-list-group>
        </b-modal>
    </div>
</template>

<script>
var axios = require('axios')
import mixin from '@/components/mixin.js'

export default {
    mixins:[mixin],
    name: 'ActionBar',
    data() {
        return {
            form: {
                CardId: ''                
            },
            alertvariant: "warning",             
            alerttxt: "",
            dismissCountDown: 0,
            caja: localStorage.getItem("posId"),
            location: localStorage.getItem("defaultlocation"),
            ModalMsg: "",
            processing: false,
        }
    },    
    methods: {
        park() {
             if (this.processing === true) {                
                return;
            }
            
            
            if (this.$store.state.curOrder == "") {
                this.ModalMsg = "Debe guardar el documento antes de aparcarlo"
                this.$refs.ModalRefPayments.show()  
            }
            else {
                this.processing = true
                this.parkSale(0).then((data) => {
                this.processing = false
                this.$store.dispatch("resetPOS")
                this.$router.push('setup')
                }).catch(error => {    
                    this.processing = false
                    this.ModalMsg = error.response.data.message
                    this.$refs.ModalRefPayments.show()   
                });      
            }
        },
        convertOrder(){
            if (this.processing === true) {                
                return;
            }
            else
            { 
                this.processing = true
                this.parkSale(0).then((data) => {
                if (this.$store.state.curOrder != ""){
                axios.post(this.ApiBaseUrl + 'PosFunctions/QuoteToOrder',
                        JSON.stringify(this.$store.state.curOrder),
                        {headers: {"Content-Type": "application/json"}})            
                .then((response) => { 
                    this.processing = false          
                    var res = response; 
                    this.$store.commit('setcurDocType', 1)
                    this.RecoverSale(response.data.return_value)
                                    
                })
                }                      
                }).catch(error => {
                    this.processing = false
                    this.ModalMsg = error.response.data.message
                    this.$refs.ModalRefPayments.show()   
                });     
            }

            
        },        
        cancelSale(){
            if (this.$store.state.orderPrePayments.length > 0)
            {
                this.ModalMsg = "Existen Anticipos. Utilice la opción Aparcar"
                this.$refs.ModalRefPayments.show()   
                return
            }
            this.ModalMsg = "Se eliminará el documento de venta. ¿Desea continuar?"
            this.$refs.ModalRefCancelSale.show()   
        },
        cancelSaleConfirmed(){
            var SalesOrder = {
                OrderNo: this.$store.state.curOrder,
                OrderType : this.$store.state.curDocType                 
            }
            
            if (SalesOrder.OrderNo != ""){                
                axios.post(this.ApiBaseUrl + 'PosFunctions/CancelDocument',
                        JSON.stringify(SalesOrder),
                        {headers: {"Content-Type": "application/json"}})            
                .then((response) => {  
                    var res = response;   
                     this.$store.dispatch("resetPOS")
                     this.$router.push('setup')                               
                })
                .catch(error => {
                    this.ModalMsg = error.response.data.message
                    this.$refs.ModalRefPayments.show()   
                });
            }     
            else{
                this.$store.dispatch("resetPOS")
                this.$router.push('setup')  
            }
        }             
    }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>